import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { EmployerStaffPageEMPAdmin } from 'src/pages/employers';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    accessRoles: [ReactRouteAccessKey.inherit],
    element: <EmployerStaffPageEMPAdmin />,
  },
];

export const EMPLOYER_STAFF_ROUTE: RouteProps = {
  path: appRoutes.employerStaff.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.hasEmployerRoles],
};
